import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL, securityHeaders } from "../Constants";
import { isEmpty } from "lodash";

const fetchCouncilNews = async (
  pageSize,
  pageNumber,
  councilType,
  searchKey
) => {
  return await axios.get(
    API_URL +
      `/api/Council/GetCouncilNews/${pageSize}/${pageNumber}/${councilType}?${
        !isEmpty(searchKey) ? "SearchBy=" + searchKey : ""
      }`,
    {
      headers: securityHeaders,
    }
  );
};

const fetchCouncilTeams = async (councilType, searchKey) => {
  return await axios.get(
    API_URL +
      `/api/Council/GetCouncilTeams?CouncilType=${councilType}${
        !isEmpty(searchKey) ? "&SearchBy=" + searchKey : ""
      }`,
    {
      headers: securityHeaders,
    }
  );
};

const fetchCouncilTeamsById = async (id) => {
  return await axios.get(API_URL + `/api/Council/GetCouncilTeamsById/${id}`, {
    headers: securityHeaders,
  });
};

const fetchCouncilNewsById = async (id) => {
  return await axios.get(API_URL + `/api/Council/GetCouncilNewsById/${id}`, {
    headers: securityHeaders,
  });
};

const fetchCouncilCalendarById = async (id) => {
  return await axios.get(
    API_URL + `/api/Council/GetCouncilCalendarById/${id}`,
    {
      headers: securityHeaders,
    }
  );
};

const fetchCouncilCalendar = async () => {
  return await axios.get(API_URL + `/api/Council/GetCouncilCalendar`, {
    headers: securityHeaders,
  });
};

const deleteMember = (id) => {
  return axios.post(
    API_URL + `/api/Council/DeleteCouncilTeams/${id}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

const deleteCouncilNews = (id) => {
  return axios.post(
    API_URL + `/api/Council/DeleteCouncilNews/${id}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

export const useFetchCouncilNews = (
  pageSize,
  pageNumber,
  councilType,
  searchKey
) => {
  return useQuery({
    queryKey: [`councilNews-${councilType}`],
    queryFn: () =>
      fetchCouncilNews(pageSize, pageNumber, councilType, searchKey),
    enabled: true,
    refetchOnWindowFocus: false,
  });
};

export const useFetchCouncilTeams = (councilType, searchKey) => {
  return useQuery({
    queryKey: [`councilTeams-${councilType}`],
    queryFn: () => fetchCouncilTeams(councilType, searchKey),
    enabled: true,
    refetchOnWindowFocus: false,
  });
};

export const useFetchCouncilTeamsById = (id) => {
  return useQuery({
    queryKey: [`councilTeam-${id}`],
    queryFn: () => fetchCouncilTeamsById(id),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useFetchCouncilNewsById = (id) => {
  return useQuery({
    queryKey: [`councilNewsById-${id}`],
    queryFn: () => fetchCouncilNewsById(id),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useFetchCouncilCalendarById = (id) => {
  return useQuery({
    queryKey: [`councilCalendarById-${id}`],
    queryFn: () => fetchCouncilCalendarById(id),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useFetchCouncilCalendar = () => {
  return useQuery({
    queryKey: ["councilCalendar"],
    queryFn: () => fetchCouncilCalendar(),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export const useDeleteMember = (id) => {
  return useMutation(() => deleteMember(id));
};

export const useDeleteCouncilNews = (id) => {
  return useMutation(() => deleteCouncilNews(id));
};
